import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { Script } from 'gatsby';
import '../css/DonateModal.css';

export default function DonationPopup() {
    const [showModal, setShowModal] = useState(false);

    /* useEffect(() => {
        const sessionDismissed = sessionStorage.getItem('donateModalDismissed');
        const lastDismissed = localStorage.getItem('donateModalDismissed');

        // Check if modal was dismissed for this session or if one month has passed since last dismissal
        if (!sessionDismissed && (!lastDismissed || (new Date() - new Date(lastDismissed)) > 30 * 24 * 60 * 60 * 1000)) {
            const timer = setTimeout(() => {
                setShowModal(true); // Open the modal after 10 seconds
            }, 30000);

            return () => clearTimeout(timer); // Clean up the timer if the component unmounts
        }
    }, []); */

    const handleClose = () => {
        setShowModal(false);
        sessionStorage.setItem('donateModalDismissed', 'true'); // Mark modal as dismissed for the session
    };

    return (
        <>
            <Modal
                show={showModal}
                onHide={handleClose}
                aria-labelledby="donate-modal"
                dialogClassName="custom-modal-width"
                centered
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <Row>
                        <Col md={{ span: '6', order: 'last' }}>
                            <h2 className='popupheading'>Support World Savvy!</h2>
                            <div className='team-bio-image white-circle-ptrn-col popupimage' style={{ maxWidth: '257px', margin: '0 auto' }}>
                                <StaticImage src='../images/donate-profile-image.jpg' alt='Profile image' />
                            </div>
                            <p className='popuptext'>
                                We believe that education is the foundation of a thriving, multi-ethnic democracy. Our work transforms schools into places where students learn how to think critically, collaborate across differences, and engage constructively in their communities. Support our critical mission today.
                            </p>
                        </Col>
                        <Col md={{ span: '6', order: 'first' }}>
                            <div className='donate-frm-script-sec'>
                                <div
                                    id='fr-placed-form-container-39849'
                                    className='funraise-form-container'
                                    style={{ minHeight: `416px`, marginTop: '0px' }}
                                ></div>
                                <Script id='popdonationformscript'>{`
                    (function(f,u,n,r,a,i,s,e){var data={window:window,document:document,tag:"script",data:"funraise",orgId:f,uri:u,common:n,client:r,script:a};var scripts;var funraiseScript;data.window[data.data]=data.window[data.data]||[];if(data.window[data.data].scriptIsLoading||data.window[data.data].scriptIsLoaded)return;data.window[data.data].loading=true;data.window[data.data].push("init",data);scripts=data.document.getElementsByTagName(data.tag)[0];funraiseScript=data.document.createElement(data.tag);funraiseScript.async=true;funraiseScript.src=data.uri+data.common+data.script+"?orgId="+data.orgId;scripts.parentNode.insertBefore(funraiseScript,scripts)})('9d1b91e4-a945-461b-9aa4-ccd834661c36','https://assets.funraise.io','/widget/common/2.0','/widget/client','/inject-form.js');
                  `}</Script>
                                <Script id='popdonationformconfiguration'>{`
                    window.funraise.push('create', { form: 39849 }, {
                      selector: '#fr-placed-form-container-39849',
                      type: 'grow_contained',
                    });
                  `}</Script>
                                <Script id='popdonationevent'>
                                    {`
                      window.funraise.push('onSuccess', { form: 39849 }, function(donor, donation) {
                        // Set the dismissal date in localStorage for one month
                        localStorage.setItem('donateModalDismissed', new Date().toISOString());
                        
                        // Close the modal and prevent it from showing for one month
                        const modal = document.querySelector('[aria-labelledby="donate-modal"]');
                        if (modal) {
                          const closeButton = modal.querySelector('.btn-close');
                          if (closeButton) {
                            closeButton.click(); // Close the modal programmatically
                          }
                        }
  
                        
                      });
                    `}
                                </Script>
                            </div>
                        </Col>

                    </Row>
                </Modal.Body>
            </Modal>

            {/* Funraise onSuccess Event for Form Submission */}

        </>
    );
}
